import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { Search } from '../Search';
/**
 * Used for the Listino Prezzi section. 
 */
class SelectCliente extends Component {

    constructor(props) {
        super(props);
        
        this.toggle = this.toggle.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.toggleCodiceSearch = this.toggleCodiceSearch.bind(this);

        this.state = {
             //dropdown open or closed
            dropdownOpen: false,
            //dropdown text that is displayed
            dropdownText: "Seleziona un Cliente", 
            //dropdown data
            clienti: [],
            //dropdown open or closed
            searchDropdown: false,
            //search text
            searchText: "",
            //clienti from search
            searchClienti: [],
            //codice search dropdown,
            codiceSearchDropdown: false,
            //search codice text
            codiceSearchText: "",
             //clienti from search of codice
            codiceSearchClienti: "",
        };
    
    }

    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */

    dropdownOnSelect = (cliente) => {
        this.setState({
            dropdownText: cliente.ragSoc
        }, () => this.props.clienteSelected(cliente))
        
    }

    /**
     * Handles when the dropdown list is expanded or collapsed
     */
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    toggleSearch() {
        this.setState({
            searchDropdown: !this.state.searchDropdown
        });
    }

    toggleCodiceSearch() {
        this.setState({
            codiceSearchDropdown: !this.state.codiceSearchDropdown
        })
    }

    handleSearchChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        }, () => this.props.clienteSearch())
    }

    handleSearchSubmit = (e) => {
        e.preventDefault();
        
        this.props.clienteSearch(this.state.searchText)
    }

    handleCodiceSearchChange = (e) => {
        this.setState({
            codiceSearchText: e.target.value,
        }, () => this.props.clienteCodiceSearch())
    }

    handleCodiceSearchSubmit = (e) => {
        e.preventDefault();
        
        this.props.clienteCodiceSearch(this.state.codiceSearchText)
    }



    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <Container className="d-flex align-items-center justify-content-center">
              <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Ricerca Clienti</h5>
            </Container>
        );

        //Creates the Level 2 Dropdown menu
        const clientiDropDown = (
            <Container style={{paddingTop: "25px"}}>
                <Row>
                    <Col className="my-auto" style={{width: '100%', textAlign: 'center'}}>
                        <Dropdown style={{width: '100%', textAlign: 'center'}} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                            <DropdownToggle caret>
                                {this.state.dropdownText}
                            </DropdownToggle>
                            <DropdownMenu
                                modifiers={{
                                    setMaxHeight: {
                                      enabled: true,
                                      order: 890,
                                      fn: (data) => {
                                        return {
                                          ...data,
                                          styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: "50vh",
                                          },
                                        };
                                      },
                                    },
                                    computeStyle: {
                                        gpuAcceleration: false
                                    }
                                }}> 
                                {this.props.clienti.map(cliente => {
                                    return (
                                        <DropdownItem key={cliente.codiceCliente} id={cliente.codiceCliente} onClick={() => this.dropdownOnSelect(cliente)} style={{color: "#011e41"}}>
                                            {cliente.insegnaEsterna ? `${cliente.ragSoc} - ${cliente.insegnaEsterna}` : cliente.ragSoc}
                                        </DropdownItem>
                                    )
                                })}
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                </Row>
            </Container>
        );

        const searchResult = (
            <Container style={{paddingTop: "25px"}}>
                <Row>
                    <Col className="my-auto" style={{width: '100%', textAlign: 'center'}}>
                        <Dropdown style={{width: '100%', textAlign: 'center'}} isOpen={this.state.searchDropdown} toggle={this.toggleSearch}>
                            <DropdownToggle caret>
                                Risultati di Ricerca
                            </DropdownToggle>
                            <DropdownMenu right 
                                modifiers={{
                                    setMaxHeight: {
                                      enabled: true,
                                      order: 890,
                                      fn: (data) => {
                                        return {
                                          ...data,
                                          styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: "50vh",
                                          },
                                        };
                                      },
                                    },
                                    computeStyle: {
                                        gpuAcceleration: false
                                    }
                                  }}> 
                                {this.props.searchClienti.map(cliente => {
                                    return (
                                        <DropdownItem key={cliente.codiceCliente} id={cliente.codiceCliente} onClick={() => this.dropdownOnSelect(cliente)}>
                                                {cliente.insegnaEsterna ? `${cliente.ragSoc} - ${cliente.insegnaEsterna}` : cliente.ragSoc}
                                        </DropdownItem>
                                    ) 
                                })}
                            </DropdownMenu>
                        </Dropdown >
                    </Col>
                </Row>  
            </Container>            
        );

        const searchCodice = (
            <Container style={{paddingTop: "25px"}}>
                <Row>
                    <Col className="my-auto" style={{width: '100%', textAlign: 'center'}}>
                        <Dropdown style={{width: '100%', textAlign: 'center'}} isOpen={this.state.codiceSearchDropdown} toggle={this.toggleCodiceSearch}>
                            <DropdownToggle caret>
                                Risultati di Ricerca
                            </DropdownToggle>
                            <DropdownMenu right 
                                modifiers={{
                                    setMaxHeight: {
                                      enabled: true,
                                      order: 890,
                                      fn: (data) => {
                                        return {
                                          ...data,
                                          styles: {
                                            ...data.styles,
                                            overflow: 'auto',
                                            maxHeight: "50vh",
                                          },
                                        };
                                      },
                                    },
                                    computeStyle: {
                                        gpuAcceleration: false
                                    }
                                  }}> 
                                {this.props.searchCodiceClienti.map(cliente => {
                                    return (
                                        <DropdownItem key={cliente.codiceCliente} id={cliente.codiceCliente} onClick={() => this.dropdownOnSelect(cliente)}>
                                                {cliente.insegnaEsterna ? `${cliente.ragSoc} - ${cliente.insegnaEsterna}` : cliente.ragSoc}
                                        </DropdownItem>
                                    ) 
                                })}
                            </DropdownMenu>
                        </Dropdown >
                    </Col>
                </Row>  
            </Container> 
        )

        return (
            <Container className="d-flex align-items-start" fluid> 
                <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                    {titolo}
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}} style={{width: "100%"}}>
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Seleziona Clienti</h4>
                            </Col>
                        </Row>
                    </Container>
                    {clientiDropDown}
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}} style={{width: "100%"}}>
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Per Codice</h4>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col xs={{size: 6}} style={{width: "100%"}}>
                                <Search handleSearchChange={this.handleCodiceSearchChange} handleSearchSubmit={this.handleCodiceSearchSubmit}/>
                            </Col>
                        </Row>
                    </Container>
                    {this.props.searchCodiceComplete ? 
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col style={{width: "100%"}}>
                                {this.props.searchCodiceClienti.length > 0 ? searchCodice : `cliente non trovato, ripetere la ricerca`}
                            </Col>
                        </Row>
                    </Container> : null
                    }
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col className="d-flex align-items-center justify-content-center" xs={{size: 6}} style={{width: "100%"}}>
                                <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Per Rag Soc/Indirizzo</h4>
                            </Col>
                        </Row>
                    </Container>
                    <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                        <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                            <Col xs={{size: 6}} style={{width: "100%"}}>
                                <Search handleSearchChange={this.handleSearchChange} handleSearchSubmit={this.handleSearchSubmit}/>
                            </Col>
                        </Row>
                    </Container>
                    {this.props.searchComplete ? 
                        <Container className="d-flex align-items-center justify-content-center" style={{paddingTop: "25px"}}>
                            <Row className="d-flex align-items-center justify-content-center" style={{width: "100%"}}>
                                <Col style={{width: "100%"}}>
                                    {this.props.searchClienti.length > 0 ? searchResult : `cliente non trovato, ripetere la ricerca`}
                                </Col>
                            </Row>
                        </Container> : null
                    }
                </Row>
            </Container>
            
        )
    }
}

export default SelectCliente;


// WEBPACK FOOTER //
// ./src/components/Cliente/SelectCliente.js